// extracted by mini-css-extract-plugin
export default {"TitleDialogContent":"ModalEstado_TitleDialogContent__hbyUY","TitleDialogTexto":"ModalEstado_TitleDialogTexto__+DVnx"};